import { render } from "./LandingView.vue?vue&type=template&id=0c6c32dc&scoped=true&ts=true"
import script from "./LandingView.vue?vue&type=script&lang=ts"
export * from "./LandingView.vue?vue&type=script&lang=ts"

import "./LandingView.vue?vue&type=style&index=0&id=0c6c32dc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c6c32dc"]])

export default __exports__